import { cloneDeep } from 'lodash';
import { trackConfig, type IFramework } from '@/framework';
import { LayerType, VectorType, type ILayerProps, type IVectorLayerProps } from '@/version-types';
import { pushHistory, updateLayer } from '../utils';

export interface IPieceColor {
    /**
     * 设置 graph 类型矢量图层片段颜色
     * @param layerID - 图层 id
     * @param index - 片段索引
     * @param color - 颜色
     * @returns
     */
    setPieceColor(
        layerID: string,
        index: number,
        color: string,
        options?: { writeHistory: boolean },
    ): ILayerProps | void;
}

export class PieceColor implements IPieceColor {
    private prevLayer: ILayerProps | null = null;

    constructor(private framework: IFramework) {}

    setPieceColor(layerID: string, index: number, color: string, options = { writeHistory: true }) {
        const prevLayer = (() => {
            if (this.prevLayer) return this.prevLayer;
            this.prevLayer = this.framework.getLayer(layerID, true);
            return this.prevLayer;
        })();
        if (!prevLayer || prevLayer.layerType !== LayerType.VECTOR_LAYER) return;

        const prevLayerData = prevLayer.data as IVectorLayerProps;
        const { vectorType, colors: prevColors } = prevLayerData;

        if (vectorType !== VectorType.Graph || prevColors.length === 0) return;
        if (index < 0 || index >= prevColors.length) return;

        const { writeHistory } = options;

        if (writeHistory) {
            const nextLayer = this.framework.getLayer(layerID, true);

            pushHistory(this.framework, prevLayer, nextLayer, trackConfig[LayerType.VECTOR_LAYER].colors);
            this.prevLayer = null;

            return nextLayer;
        }

        const nextColors = cloneDeep(prevColors);
        nextColors[index].color = color;

        const nextLayerData: IVectorLayerProps = { ...prevLayerData, colors: nextColors };
        const nextLayer: ILayerProps = { ...prevLayer, data: nextLayerData };

        updateLayer(this.framework, nextLayer);

        return nextLayer;
    }
}
